import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
import { APIInfo } from '../Invoices'
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type TokenAuthorization = {
    AccessToken: string;
    FullAuthTokenURL: string;
}

type State = {
    hasAccessToken: boolean;
    message: string;
    isLoading: boolean;
    fullAuthTokenURL: string;
    processInvoices: boolean;
    apiInfo: APIInfo;
}

const centerImg = {
    position: "absolute",
    left: "50%",
    top: "50%",
    width: "200px",
    height: "200px",
    marginTop: "-100px",
    marginLeft: "-100px"

} as React.CSSProperties;

const centerMessage = {
    position: "absolute",
    left: "50%",
    top: "50%",
    width: "200px",
    height: "200px",
    marginTop: "125px",
    marginLeft: "-100px",
    textAlign: "center"

} as React.CSSProperties;

class QBAuthTokenDialog extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            hasAccessToken: false,
            message: '',
            isLoading: false,
            fullAuthTokenURL: '',
            processInvoices: false,
            apiInfo: null
        }
    }

    public componentWillMount() {        
        const queryString = require('query-string');
        const parsed = queryString.parse(location.search);

        let _parsedState: any = null;
        if (parsed && parsed.state) {
            if (!parsed.error) {
                _parsedState = parsed.state.split("|");

                if (parsed.final && parsed.final == "true") {
                    //We are now in the proper final subdomain, verify token and proceed
                    //this.hasAccessToken(parsed.code, parsed.realmId);  //verify fix realmid                   
                    //this.hasAccessToken(parsed.code, parsed.realmId);

                    this.getAPIInfoAndValidateToken(parsed.code, (parsed.realmId) ? parsed.realmId : ""); //only qb passes realmid                    
                } else { //if (parsed.state && parsed.state === 'CoreAuth') {
                    //QBO has redirected to base url https://anc.daycarium.com.  We must redirect to proper sub-domain where it was actually called from
                    window.location.href = _parsedState[1] + window.location.search + "&final=true"
                }
            } else
                this.setState({ hasAccessToken: false, isLoading: false, message: "Exiting...", processInvoices: false }, () => setTimeout(() => { self.close(); }, 1500));
        } else {
            //localStorage.setItem("QB_REDIRECT_URL", window.location.protocol + "//" + window.location.host + window.location.pathname); //Need this to support sub-domains
            //this.setState({ validateAPITokenURL: parsed.validateAPITokenURL }, () => this.hasAccessToken("", ""));            
            this.getAPIInfoAndValidateToken("", "");
        }



        //if (parsed && parsed.final && parsed.final == "true") {
        //    // this.hasAccessToken(parsed.code, parsed.realmId);
        //} else if (parsed && parsed.state && parsed.state === 'CoreAuth') {
        //}
    }

    private getAPIInfoAndValidateToken(auth_code: string, auth_realmid: string) {        
        this.setState({ isLoading: true });
        fetchApi('/api/Billing/GetAPIInfo')
            .then((_data: APIInfo) => {                
                this.setState({
                    apiInfo: _data
                }, () => this.hasAccessToken(auth_code, auth_realmid));
            }).catch(() => {
                alert("Can't connect to server");
            });
    }

    private hasAccessToken(auth_code: string, auth_realmid: string) {        
        const data = {
            AuthCode: auth_code,
            RealmId: auth_realmid
        }
        //this.setState({ isLoading: true }); //set from getAPIInfoAndValidateToken
        //fetchApi('/api/Billing/ValidateQBToken', data, 'POST')
        var link = this.state.apiInfo.Links.filter((x: ApiLink) => x.Rel === 'ValidateToken')[0].Href;
        fetchApi(link, data, 'POST')
            .then((_data: TokenAuthorization) => {
                if (!_data.AccessToken) {
                    this.setState({
                        fullAuthTokenURL: _data.FullAuthTokenURL + "|" + this.getSubDomain() //+ "|" + link //could pass link in state and fetch it after, but no need.  We'll just call getAPIInfo again
                    }, () => this.RedirectToSignIn());
                } else {
                    //this.setState({ hasAccessToken: true, isLoading: false }, () => self.close());
                    this.setState({ hasAccessToken: true, isLoading: false, message: "Successfully Authorized.\nScreen will now close.", processInvoices: true }, () => setTimeout(() => { self.close(); }, 2500));
                }
            }).catch(() => {
                alert("Can't connect to server");
            });
    }

    private getSubDomain(): string {
        return window.location.protocol + "//" + window.location.host + window.location.pathname;
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="QuickBooks Import" />
            <input type="hidden" id="processInvoices" value={String(this.state.processInvoices)} />
            {this.state.isLoading && <LoadingPanel />}
            {!this.state.isLoading && this.state.message.length > 0 && <div style={centerMessage}><label>{this.state.message}</label></div>}
            {this.state.apiInfo && <div style={centerImg}>
                <img src={this.state.apiInfo.ImageURL} style={centerImg} />
            </div>}

            {/*
            <a href="#" onClick={(e) => this.requestBillingPeriods(e)} style={centerImg}>
                <img src="images/qbonline.png" style={centerImg}/>
            </a>
            */}

        </React.Fragment>;
    }

    private openWindow(name: string, url: string, widthpct: number, heightpct: number): any {
        return window.open(url, name, 'toolbar=0, location=0, directories=0, status=0, menubar=0, scrollbars=1, resizable=1,width =' + window.screen.width * widthpct + ', height =' + window.screen.height * heightpct + ',left=' + (window.screen.width - (window.screen.width * widthpct)) / 2 + ',top=' + (window.screen.height - (window.screen.height * heightpct)) / 2 + "'");
    }

    private RedirectToSignIn() {
        window.location.href = this.state.fullAuthTokenURL;
        return false;
    }
}

export default QBAuthTokenDialog;
